// extracted by mini-css-extract-plugin
export default {"listaCanais":"ListaCanais_listaCanais__4k4bR","lista-canais":"ListaCanais_lista-canais__nlBMX"};